export default $client => ({
    get() {
        return $client.get('currencies');
    },
});
